import { useUserStore } from '../../../../store/useUserStore';
import moment from 'moment';
import { usePrivateQnaDetailQuery } from '../../../../queries';

import { stripHtmlTags } from '../../../../utility/stripHtmlTag';
import FullHeightContainer from '../../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../../component/common/TopHeaderWithPrev';
import Divider from '../../../../component/common/Divider';

function PostDetail({ drawerOpen, onClickPrev, postId = null }) {
  const user = useUserStore();

  const { data: detail } = usePrivateQnaDetailQuery(postId || 0, {
    enabled: drawerOpen && !!user && !!postId,
  });

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title="1:1 문의" onClickPrev={onClickPrev} />
      <div className="pageInner">
        <div className="font-[700] text-[#1C1C1C] text-[18px] mt-5">{detail?.title}</div>
        <div className="font-[400] text-[#969696] text-[12px] mb-5">
          {moment(detail?.createdAt).format('YYYY.MM.DD')}
        </div>
        <div className="w-full text-left text-[14px] text-[#363636] font-[400]">
          <div className="">{detail?.content}</div>
        </div>
        <div className="my-[30px] w-full">
          <Divider />
        </div>
        <div className="w-full text-left text-[14px] text-[#363636] font-[400]">
          <div className="font-[700] text-[#1C1C1C] text-[16px] mb-2">답변</div>
          <div className="w-full flex flex-col justify-start items-start gap-4 text-[#363636] font-[400] text-[14px]">
            {detail?.comments?.length > 0 ? (
              detail?.comments?.map((comment) => (
                <div key={comment.id}>{stripHtmlTags(comment?.content)}</div>
              ))
            ) : (
              <div className="text-[#969696]">답변이 없습니다.</div>
            )}
          </div>
        </div>
      </div>
    </FullHeightContainer>
  );
}

export default PostDetail;
